module.exports = __webpack_public_path__ + "img/tpc-11.ca2c3f3f.webp";